import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { ResidentShiftHandoverTemplate } from "app/features/shiftHandover/templates/ResidentShiftHandoverTemplate";
import { Redirect } from "expo-router";
import { View } from "ui/atoms/view";

export function ResidentShiftHandoverScreen() {
  const { residentId } = useResidentContext();

  if (!residentId) {
    return <Redirect href={"/residents"} />;
  }
  return (
    <View className="resident-container">
      <ResidentShiftHandoverTemplate residentId={residentId} isEditing />
    </View>
  );
}
